import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SmallTagRounded, } from '@/components/ui/Tag/SmallTagRounded';
import { PROFESSIONAL_HOTLINE_STATUS_OPEN, PROFESSIONAL_HOTLINE_STATUS_SCHEDULING, PROFESSIONAL_HOTLINE_STATUS_SCHEDULED, PROFESSIONAL_HOTLINE_STATUS_COMPLETED, PROFESSIONAL_HOTLINE_STATUS_CANCELED, } from '@/feature/hotline/professional/constant/status';
/** 表示設定 */
export const settings = {
    [PROFESSIONAL_HOTLINE_STATUS_OPEN.value]: {
        color: 'orange',
        text: PROFESSIONAL_HOTLINE_STATUS_OPEN.label,
    },
    [PROFESSIONAL_HOTLINE_STATUS_SCHEDULING.value]: {
        color: 'lightBlue',
        text: PROFESSIONAL_HOTLINE_STATUS_SCHEDULING.label,
    },
    [PROFESSIONAL_HOTLINE_STATUS_SCHEDULED.value]: {
        color: 'lightOrange',
        text: PROFESSIONAL_HOTLINE_STATUS_SCHEDULED.label,
    },
    [PROFESSIONAL_HOTLINE_STATUS_COMPLETED.value]: {
        color: 'darkBlue',
        text: PROFESSIONAL_HOTLINE_STATUS_COMPLETED.label,
    },
    [PROFESSIONAL_HOTLINE_STATUS_CANCELED.value]: {
        color: 'darkGray',
        text: PROFESSIONAL_HOTLINE_STATUS_CANCELED.label,
    },
};
/**
 * 匿名コンサルホットライン コンサル ステータスタグ
 */
export const HotlineProStatusTag = (props) => {
    const { className = '', size = 'md', status } = props;
    return (_jsx(SmallTagRounded, Object.assign({ className: className, color: settings[status].color, size: size }, { children: settings[status].text })));
};
